module.exports = __webpack_public_path__ + "img/icon_temperature_white.f728d89e.svg";